import {
  isModuleResourceResponseDTO,
  ModuleResourceResponseApi,
} from "../../DTO/ServerResponseType/Module/ModuleResource";
import {
  isResourceResponseDTO,
  ResourceResponseApi,
} from "../../DTO/ServerResponseType/Resource/Resource";
import {
  isTaskWithContentResponseDTO,
  TaskWithContent,
} from "../../DTO/ServerResponseType/Task/Task";
import { ModuleResourceRowDTO } from "../../ProfileWindow/AdminWindows/ModuleEditWindow/DTO/ModuleResourceRowDTO";

export class ModuleResourceStore {
  public moduleResource: ModuleResourceRowDTO = new ModuleResourceRowDTO();

  setModuleResource = (
    moduleResourceOrResourceOrTask?:
      | ResourceResponseApi
      | TaskWithContent
      | ModuleResourceResponseApi
  ) => {
    if (isModuleResourceResponseDTO(moduleResourceOrResourceOrTask))
      this.moduleResource.setFromModuleResourceResponse(
        moduleResourceOrResourceOrTask
      );
    else if (isResourceResponseDTO(moduleResourceOrResourceOrTask)) {
      this.moduleResource.setFromResourceResponse(
        moduleResourceOrResourceOrTask
      );
    } else if (isTaskWithContentResponseDTO(moduleResourceOrResourceOrTask)) {
      this.moduleResource.setFromTaskResponse(moduleResourceOrResourceOrTask);
    } else {
      this.moduleResource.clear();
    }
  };

  onChangeType = (
    eventOrType: React.FormEvent<HTMLSelectElement> | number
  ): void => {
    if (typeof eventOrType === "number")
      this.moduleResource.onChangeType(eventOrType);
    else
      this.moduleResource.onChangeType(
        parseInt(
          eventOrType.currentTarget.options[
            eventOrType.currentTarget.selectedIndex
          ].value
        )
      );
  };

  onChangeRequired = () => {
    this.moduleResource.onChangeRequired(!this.moduleResource.required);
  };

  onChangeOrder = (event: React.FormEvent<HTMLSelectElement>) => {
    let eventOption =
      event.currentTarget.options[event.currentTarget.selectedIndex];

    if (eventOption)
      this.moduleResource.onChangeOrder(parseInt(eventOption.value));
  };
}
